import React, { useEffect, useState } from "react";
import feather from "feather-icons";
import { Link } from "react-router-dom";

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  useEffect(() => {
    setTimeout(() => feather.replace(), 200);
  }, []);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqList = [
    {
      q: "What is NEXORA Token?",
      a: "NEXORA is a utility token designed to empower the next generation through blockchain technology in education, culture, health, and civic engagement. It serves as the native token for the NEXORA ecosystem, enabling access to services, governance, and rewards.",
    },
    {
      q: "How can I buy NEXORA tokens?",
      a: (
        <>
          NEXORA tokens can be purchased during our presale or through decentralized
          exchanges after launch. Visit our{" "}
          <Link to="/buy" className="text-neonPink hover:underline">
            Buy NEXORA
          </Link>{" "}
          page for details.
        </>
      ),
    },
    {
      q: "What is the total supply of NEXORA?",
      a: (
        <>
          The total supply of NEXORA is <strong>1,000,000,000 tokens</strong>.  
          See our{" "}
          <Link to="/tokenomics" className="text-neonBlue hover:underline">
            Tokenomics
          </Link>{" "}
          page for detailed allocations.
        </>
      ),
    },
    {
      q: "How can I participate in governance?",
      a: "NEXORA holders can participate in governance by staking their tokens in the NEXORA DAO. Each NEXORA token represents one vote for proposals and decisions.",
    },
    {
      q: "What wallets support NEXORA?",
      a: "NEXORA is an ERC-20 compatible token supported by wallets such as MetaMask, Trust Wallet, Ledger, and Trezor. You can add it using the official contract address.",
    },
    {
      q: "How can I get involved with NEXORA projects?",
      a: (
        <>
          <ul className="list-disc list-inside space-y-2 mt-2">
            <li>Join our Discord and Telegram communities</li>
            <li>Submit proposals for educational or cultural projects</li>
            <li>Become a content creator for NEXORA Academy</li>
            <li>Apply to the Ambassador Program</li>
          </ul>
          <p className="mt-4">
            Visit the{" "}
            <Link to="/projects" className="text-neonPink hover:underline">
              Projects
            </Link>{" "}
            page for current opportunities.
          </p>
        </>
      ),
    },
  ];

  return (
    <div className="text-white">
      {/* Header */}
      <div className="text-center mb-16">
        <h1 className="text-5xl font-bold mb-6 text-transparent bg-clip-text bg-gradient-to-r from-neonPink to-neonBlue">
          Frequently Asked Questions
        </h1>
        <p className="text-lg text-gray-300 max-w-3xl mx-auto">
          Find answers to common questions about the NEXORA Token and its ecosystem.
        </p>
      </div>

      {/* FAQ Accordions */}
      <div className="bg-gray-900 bg-opacity-70 rounded-2xl p-8 border border-neonPurple/40">
        {faqList.map((item, index) => (
          <div
            key={index}
            className={`border-b border-gray-800 pb-6 ${
              index === faqList.length - 1 ? "border-none" : ""
            }`}
          >
            <button
              className="flex justify-between items-center w-full text-left group"
              onClick={() => toggleFAQ(index)}
            >
              <h3
                className={`text-xl font-semibold transition ${
                  openIndex === index ? "text-neonPink" : "group-hover:text-neonPink"
                }`}
              >
                {item.q}
              </h3>
              <i
                data-feather="chevron-down"
                className={`w-6 h-6 transition-transform ${
                  openIndex === index ? "rotate-180 text-neonPink" : ""
                }`}
              ></i>
            </button>
            {openIndex === index && (
              <div className="pt-4 text-gray-300 animate-fadeIn">{item.a}</div>
            )}
          </div>
        ))}
      </div>

      {/* Contact CTA */}
      <div className="mt-12 text-center">
        <p className="text-gray-400 mb-4">Still have questions?</p>
        <Link
          to="/contact"
          className="inline-block px-6 py-3 border border-neonBlue rounded-lg hover:bg-neonBlue hover:text-white transition"
        >
          Contact Our Team
        </Link>
      </div>
    </div>
  );
};

export default FAQ;
